<template>
    <slideout-content v-on="$listeners">
        <template #header>
            <div>
                <a :href="baseUrl + locale + '/help'" target="_blank"
                   class="navbar-brand mb-0 h3 fw-bold text-nowrap me-auto align-items-center">
                    <i class="fi fi-rr-interrogation d-inline-flex pe-2"></i>
                    {{ trans('general.help_center.title') }}
                </a>
                <a v-if="category_url" class="d-block mt-1" :href="category_url" target="blank">
                    <i class="fi fi-rr-link"></i>
                    {{ trans('general.help_center.view_category') }}
                </a>
            </div>
        </template>
        <template #content>
            <iframe class="embed-responsive-item iframe-content" :src="src" frameborder="0"></iframe>
        </template>
    </slideout-content>
</template>

<script>
import SlideoutContent from "./SlideoutContent.vue";

export default {
    name: "HelpContent",
    components: {SlideoutContent},
    props: {
        content: {
            type: Object,
            required: true
        },
        locale: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            baseUrl: appConfig.landingUrl + '/',
            src: '',
            category_id: null,
            category_url: null
        }
    },
    methods: {
        fillContent() {
            this.src = this.baseUrl + this.locale + '/help/' + this.content.WEB_URL + '?app';

            if(this.content.CATEGORY_ID != null) {
                this.category_url = this.baseUrl + this.locale + '/help/search?category=' + this.content.CATEGORY_ID;
            } else {
                this.category_url = null;
            }

        },
        getLang() {
            return document.documentElement.lang
        },
        closePanel(event) {
            event.preventDefault()
            this.$emit('closePanel', {});
        },
    },
    mounted() {
        this.fillContent();
    }
}
</script>

<style scoped>
.iframe-content {
    width: 100%;
    height: calc(100vh - 110px);
}
</style>
